export const environment = {
  production: false,
 
  // AWS Cognito Configuration
  cognito: {
    userPoolId: 'ap-southeast-2_L3HS35vIG',
    userPoolWebClientId: '182ctgplpjg6lsl48qdomt6v38',
    region: 'ap-southeast-2',
  },
 
  // API Configuration
  api: {
    baseUrl: 'https://suppliers-uat.winning.com.au/supplier'
  },
 
  // Cognito OAuth Configuration
  cognitoOAuth: {
    clientId: '182ctgplpjg6lsl48qdomt6v38',
    redirectUri: 'https://suppliers-uat.winning.com.au/login/callback',
    domain: 'https://winnsdhuatdomain.auth.ap-southeast-2.amazoncognito.com'
  },
  
  hmac : {
    key : "",
    secretName: 'winn-sdh-apse2-dev1-hmac-sm',
  }
};